import { getVisible } from '../../documents';
import { DocumentMap, IDocument } from '../../../types';

export function getLastObject<T extends IDocument>(docs: DocumentMap | undefined): T | undefined {
  const visibleDocs = docs ? getVisible({ documentsHash: docs }) : [];
  const key = Object.keys(docs || {}).pop(); // last key
  if (!key) {
    return;
  }
  return visibleDocs.pop()?.item as T;
}
